<template>
  <div id="SIP-audio" v-if="visible" style="position: relative; z-index: 10">
    <el-button
      type="danger"
      icon="el-icon-close"
      circle
      style="position: fixed; bottom: 180px; left: 280px; z-index: 200"
      @click="endConn"
      ></el-button
    >
    <iframe
      id="audioIframe"
      :src="'https://live.concoai.com/r/' + robotId"
      frameborder="0"
      allow="microphone;camera;midi;encrypted-media;"
      @load="iframeLoad"
      height="200px"
      width="300px"
      style="position: fixed; bottom: 0px; left: 0px"
    ></iframe>
    <!-- <div
      v-show="options.isMini == false"
      class="rtc-wapper"
      :class="{ miniClass: options.isSmall }"
      v-drag
    >
      <div class="rtc-top-menu">
        <div class="top-time">00:15</div>
        <div class="top-buttons">
          <div
            class="buttons-small"
            @click="options.isSmall = !options.isSmall"
          >
            <i class="el-icon-d-caret"></i>
          </div>
          <div class="buttons-small" @click="options.isMini = true">
            <i class="el-icon-minus"></i>
          </div>
          <div class="buttons-close" @click="endConn">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
      <audio id="remoteAudio" controls autoplay ref="remoteAudio" style="display:none"></audio>
      <div class="rtc-robot-info">
        <img @click="connSIP" :src="imgMap.robotImg" alt="" />
        <div class="rtc-robot-name">机器人一号</div>
        <div class="robot-bgConvas">
          <canvas id="robot-bg" width="300" height="300px"></canvas>
        </div>
      </div>
      <div>
        <canvas id="out" height="150" width="450"></canvas>
      </div>
      <div class="rtc-bottom-menu">
        <div class="bottom-menu-box" @click="noVoice">
          <img
            :src="!options.noVoice ? imgMap.noVoiceImg : imgMap.voiceImg"
            alt=""
          />
          <div>静音</div>
        </div>
        <div class="bottom-menu-box" @click="endConn">
          <img :src="imgMap.closePhoneImg" alt="" />
          <div>挂断</div>
        </div>
        <el-tooltip placement="top">
          <div slot="content">
            <el-slider @change="volumeChange" v-model="options.voiceVlaue" vertical height="100px" />
          </div>
          <div class="bottom-menu-box">
            <img :src="imgMap.volumeImg" alt="" />
            <div>音量</div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div v-show="options.isMini == true" class="rtc-mini-wapper" v-drag>
      <el-avatar :src="imgMap.robotImg"></el-avatar>
      <div class="mini-menu">
        <i
          @click="noVoice"
          :class="{
            'el-icon-microphone': options.noVoice,
            'el-icon-turn-off-microphone': !options.noVoice,
          }"
        ></i>
        <div class="mini-menu-box" @click="endConn">
          <img width="25px" :src="imgMap.closePhoneImg" alt="" />
        </div>
        <el-tooltip placement="top">
          <div slot="content">
            <el-slider v-model="options.voiceVlaue" vertical height="100px" />
          </div>
          <div class="mini-menu-box">
            <img width="25px" :src="imgMap.volumeBlackImg" alt="" />
          </div>
        </el-tooltip>
      </div>
      <div class="mini-buttons">
        <i @click="endConn" class="el-icon-close"></i>
        <i @click="options.isMini = false" class="el-icon-full-screen"></i>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Wave } from "../../assets/js/wave";
import io from "socket.io-client";
import Video from "../../page/video/video.vue";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    robotId: null,
  },
  data() {
    return {
      imgMap: {
        closePhoneImg: require("../../../static/img/close-phone.png"),
        volumeImg: require("../../../static/img/volume.png"),
        volumeBlackImg: require("../../../static/img/volume-black.png"),
        noVoiceImg: require("../../../static/img/no-voice.png"),
        voiceImg: require("../../../static/img/voice-white.png"),
        miniImg: require("../../../static/img/mini.png"),
        robotImg: require("../../../static/img/robot.png"),
      },
      options: {
        voiceVlaue: 100,
        isSmall: false,
        isMini: false,
        noVoice: false,
      },
      iframeSrc: "",
      streamObj: null,
      remoteStreamObj: null,
      microWaveObj: null,
      speackerWaveObj: null,
      pc: null,
      socket: null,
      dc: null,
      media: {
        user: "",
        bridge: "",
      },
      socketOptions: {
        message: null,
        sid: null,
      },
      // showIPS: true
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    init() {
      this.microWaveObj = new Wave();
      this.speackerWaveObj = new Wave();
      this.connectSocket();
    },
    connSIP() {
      this.checkUserMedia();
    },
    async checkUserMedia() {
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;
      if (!navigator.getUserMedia) {
        this.$notify.error({
          title: "您的浏览器不支持语音功能",
          duration: 0,
        });
        return;
      }
      await this.startStream();
    },
    drawWave(type) {
      this.init();
      try {
        if (type == "local") {
          this.microWaveObj.fromStream(this.streamObj, "out", {
            type: "bars",
            colors: ["silver", "white"],
          });
        }
        if (type == "remote") {
          this.speackerWaveObj.fromStream(this.remoteStreamObj, "robot-bg", {
            type: "round wave",
            colors: ["white", "#ffda44"],
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    rtcInit() {
      const attachMediaIfReady = () => {
        console.log("attachMediaIfReady");
        this.pc.createOffer().then(this.setDescription).catch(this.handleError);
      };
      console.log('哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈')
      this.pc = new RTCPeerConnection({
        iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
      });
      this.pc.onicecandidate = (e) => {
        console.log(e, "onicecandidate");
        if (e.candidate) {
          this.socket.send({
            type: "candidate",
            candidate: e.candidate,
          });
        }
      };
      // this.pc.addStream(this.streamObj);
      console.log(this.streamObj);
      this.streamObj
        .getTracks()
        .forEach((track) => this.pc.addTrack(track, this.streamObj));
      this.pc.onaddstream = (e) => {
        console.log(e, "onaddstream");
        this.$refs.remoteAudio.srcObject = e.stream;
        this.remoteStreamObj = e.stream;
        this.drawWave("remote");
      };
      if (this.media.user == "host") attachMediaIfReady();
    },
    setDescription(offer) {
      return this.pc.setLocalDescription(offer);
    },
    // send the offer to a server to be forwarded to the other peer
    sendDescription() {
      this.socket.send(this.pc.localDescription);
    },
    connectSocket() {
      // this.socket = io("https://101.200.202.224:3000", {
      this.socket = io("https://live.concoai.com", {
        // this.socket = io("https://192.168.31.129:3000", {
        query: {
          robotId: this.robotId,
        },
      });
      this.socket.on("create", (e) => {
        console.log("create");
        this.media.user = "host";
        this.media.bridge = "create";
      });
      this.socket.on("full", () => {
        console.log("full");
        this.$notify.error({
          title: "当前机器人正在通信中，请稍后再试",
          duration: 0,
        });
      });
      this.socket.on("bridge", () => {
        console.log("--已连接");
        this.rtcInit();
      });
      this.socket.on("message", (data) => {
        console.log("message", data.type);
        this.onMessage(data);
      });
      this.socket.on("join", () => {
        console.log("join");
        this.media.user = "guest";
        this.media.bridge = "join";
        this.socket.emit("auth", { ...this.media, ...this.socketOptions });
      });
      this.socket.on("approve", ({ message, sid }) => {
        console.log("approve", message, sid);
        this.socketOptions = { message, sid };
        // this.socket.emit('accept', this.socketOptions.sid);
      });
      this.socket.emit("find");
      this.socket.on("connect_error", () => {
        let title = "通信建立失败，请检查您当前的网络和机器人的网络状况！";
        if (!this.checkNotifyIsRepat(title)) {
          this.$notify.error({
            title,
            duration: 0,
          });
        }
      });
    },
    checkNotifyIsRepat(title) {
      let notifyDomList = document.getElementsByClassName(
        "el-notification__title"
      );
      let result = null;
      if (notifyDomList.length > 0) {
        for (let index = 0; index < notifyDomList.length; index++) {
          const element = notifyDomList[index];
          if (element.innerHTML == title) {
            return (result = true);
          }
        }
      }
    },
    onMessage(message) {
      if (message.type === "offer") {
        // set remote description and answer
        this.pc
          .setRemoteDescription(new RTCSessionDescription(message))
          .then(() => this.pc.createAnswer())
          .then(this.setDescription)
          .then(this.sendDescription)
          .catch(this.handleError); // An error occurred, so handle the failure to connect
      } else if (message.type === "answer") {
        console.log(message);
        // set remote description
        this.pc.setRemoteDescription(new RTCSessionDescription(message));
      } else if (message.type === "candidate") {
        // add ice candidate
        this.pc.addIceCandidate(message.candidate);
      }
    },
    async startStream() {
      try {
        if (!this.streamObj) {
          this.streamObj = await navigator.mediaDevices.getUserMedia({
            audio: true,
          });
          this.options.noVoice = false;
        }
        this.drawWave("local");
      } catch (error) {
        this.options.noVoice = true;
        let title = "请打开浏览器麦克风权限！";
        if (!this.checkNotifyIsRepat(title)) {
          this.$notify.error({
            title,
            duration: 0,
          });
        }
      }
    },
    stopStream() {
      if (!this.streamObj) return;
      this.streamObj.getTracks().forEach((track) => track.stop());
      this.streamObj = null;
    },
    noVoice() {
      if (!this.streamObj) return;
      if (this.options.noVoice) {
        this.streamObj.getAudioTracks()[0].enabled = true;
        // this.startStream();
      } else {
        this.streamObj.getAudioTracks()[0].enabled = false;
        // this.stopStream();
      }
      this.options.noVoice = !this.options.noVoice;
    },
    endConn() {
      this.$confirm("此操作将结束语音通讯, 是否继续?", "提示", {
        confirmButtonText: "结束",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.stopStream();
          // this.socket.emit("leave");
          // this.socket.disconnect();
          // this.pc.close();
          // this.$message({
          //   type: "success",
          //   message: "通讯已挂断!",
          // });
          this.$emit("update:visible", false);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    volumeChange(e) {
      console.log(e);
      this.$refs.remoteAudio.volume = (e / 100).toFixed(2);
    },
    iframeLoad() {
      console.log("iframeLoad");
    },
  },
  components: { Video },
  directives: {
    drag(el) {
      let oDiv = el; // 当前元素
      // 禁止选择网页上的文字
      document.onselectstart = function () {
        return false;
      };
      oDiv.onmousedown = function (e) {
        // 获取可视区宽高，当前元素宽高，计算当前元素距离可视区的距离,
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;
        let disH = oDiv.offsetHeight;
        let disW = oDiv.offsetWidth;
        let wClientWidth =
          document.documentElement.clientWidth == 0
            ? document.body.clientWidth
            : document.documentElement.clientWidth;
        let wClientHeight =
          document.documentElement.clientHeight == 0
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX < 0 ? 0 : e.clientX - disX;
          let t = e.clientY - disY < 0 ? 0 : e.clientY - disY;
          l = wClientWidth > disW + l ? l : wClientWidth - disW;
          t = wClientHeight > disH + t ? t : wClientHeight - disH;
          // 移动当前元素
          oDiv.style.left = l + "px";
          oDiv.style.top = t + "px";
        };
        document.onmouseup = function (e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
      };
    },
  },
};
</script>

<style scoped lang="less">
#SIP-audio {
  .rtc-wapper {
    width: 450px;
    height: 800px;
    background-color: #191919;
    border-radius: 4px;
    position: fixed;
    user-select: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    top: 0;
    left: 0;
    z-index: 100;
    img {
      -webkit-user-drag: none;
    }
    .rtc-top-menu {
      padding: 10px 2px 0;
      position: relative;
      .top-time {
        color: #fff;
        text-align: center;
      }
      .top-buttons {
        position: absolute;
        right: 0;
        top: 10px;
        display: flex;
        color: azure;
        cursor: pointer;
        div {
          margin: 0 10px;
        }
      }
    }
    .rtc-robot-info {
      color: #fff;
      font-size: 18px;
      position: relative;
      img {
        width: 150px;
      }
      .robot-bgConvas {
        position: absolute;
        z-index: -1;
        top: -75px;
        left: 75px;
      }
    }
    .rtc-bottom-menu {
      margin-bottom: 100px;
      display: flex;
      justify-content: space-around;
      color: #fff;
      img {
        width: 100%;
        border-radius: 50%;
        background-color: #303133;
        cursor: pointer;
      }
      .bottom-menu-box {
        width: 55px;
      }
    }
  }
  .miniClass {
    height: auto;
    .rtc-robot-info {
      margin-top: 30px;
    }
    .rtc-bottom-menu {
      margin-bottom: 30px;
    }
  }
  .rtc-mini-wapper {
    position: fixed;
    z-index: 500;
    bottom: 0;
    right: 0;
    width: 200px;
    height: 45px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
    .mini-menu {
      display: flex;
      justify-content: space-between;
      width: 120px;
      height: 25px;
      cursor: pointer;
      i {
        font-size: 25px;
        color: #000;
      }
    }
    .mini-buttons {
      display: flex;
      flex-direction: column;
      height: 35px;
      justify-content: space-between;
      i {
        font-size: 10px;
        color: #000;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/audio/audio.vue